<template>
  <div class="besthit mt-2 mb-4">
    Best Hit Of The Day
  </div>
</template>

<script>
export default {
  name: 'BestHit'
}
</script>

<style scoped>
.besthit {
  background: linear-gradient(to right, #308521 , #2e3147);
  padding: 10px;
  color: #FFFFFF;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 1px;
}
</style>
